export enum DamageStatus {
  Open = 'open',
  Done = 'done',
  Rejected = 'reject',
}
